import React from 'react';
import PropTypes from 'prop-types';

import { PlayerProfileLink } from 'widgets/statspro/js/components/common/PlayerProfileLink';
import { BenchReasonLabel } from './BenchReasonLabel';

export const PlayerCell = ({
    cell,
    cellProps,
    isMainCompetition,
    isAFLW,
    benchReasonMap
}) => {
    const playerId =
        cell?.row?.values?.player?.playerId ||
        cell?.row?.original?.player?.playerId;
    const rawReason = playerId ? benchReasonMap[playerId] : null;

    return (
        <td {...cellProps} className="stats-table__cell">
            {isMainCompetition && playerId ? (
                <PlayerProfileLink
                    classes="mc-player-stats-table__player mc-player-stats-table__player--link"
                    isAFLW={isAFLW}
                    player={{
                        playerId,
                        firstName: cell.value.givenName,
                        surname: cell.value.surname
                    }}
                >
                    <span className="mc-player-stats-table__name">
                        {cell.value.givenName}{' '}
                        <strong>{cell.value.surname}</strong>
                    </span>
                    <BenchReasonLabel rawReason={rawReason} />
                </PlayerProfileLink>
            ) : (
                <div className="mc-player-stats-table__player">
                    <span className="mc-player-stats-table__name">
                        {cell.value.givenName}{' '}
                        <strong>{cell.value.surname}</strong>
                    </span>
                    <BenchReasonLabel rawReason={rawReason} />
                </div>
            )}
        </td>
    );
};

PlayerCell.propTypes = {
    cell: PropTypes.object.isRequired,
    cellProps: PropTypes.object.isRequired,
    isMainCompetition: PropTypes.bool,
    isAFLW: PropTypes.bool,
    benchReasonMap: PropTypes.object.isRequired
};
